import "./index.scss";

export const BuyGiftCardsContainer = ({ children }) => {
  return <div className="buy-gift-cards-container">{children}</div>;
};
